<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21 13.5C20.4 13.65 19.75 13.75 19.05 13.75C14.9 13.75 11.55 10.4 11.55 6.35C11.55 5.2 11.8 4.1 12.25 3.15C7.7 3.35 4 7.05 4 11.6C4 16.35 7.8 20.15 12.55 20.15C16.55 20.15 19.95 17.35 21 13.5Z"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
